module.exports = __webpack_public_path__ + "staticcomp/img/top.9dbc0cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/4/top.jpg
// module id = KvOJ
// module chunks = 39